<template>
  <div class="featured-dorms__list dorm-card__list user__list-wrp">
    <container>
      <DormDashboardHead
        :first-name="first_name"
        :last-name="last_name"
        :logo="dormLogo"
        :mail="mail1"
      ></DormDashboardHead>
      <div class="user__list-offer" style="margin-top: 40px;">
        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">YURT BİLGİLERİ</div>
          <div class="register-box_input">
            <v-input placeholder="Yurt Şube Adı" v-model="name" />
            <label for="password" v-if="emptyName" class="myValidationText"
              >Bu kısım boş geçilemez!</label
            >
            <div class="groups">
              <v-select
                :options="cities"
                placeholder="Şehir Seçiniz"
                v-model="city_id"
                style="font-weight: bold"
                @onselect="selectCity"
              />
              <v-select
                :options="districts"
                placeholder="İlçe Seçiniz"
                @onselect="selectDistrict"
              />
              <v-select
                class="big-select"
                :options="genders"
                placeholder="Yurt Tipi"
                style="width: 225%;margin-right: 0;"
                v-model="video_type"
                @onselect="selectGender"
              />
            </div>

            <div class="groups">
              <v-input
                placeholder="E-Posta Adresiniz"
                style="width: 47%"
                v-model="email"
              />
              <label for="password" v-if="falseEmail" class="myValidationText"
                >Geçersiz e-posta formatı!</label
              >
              <label for="password" v-if="emptyEmail" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <v-input
                placeholder="Telefon"
                style="width: 47%"
                v-model="phone"
              />
              <label for="phone" v-if="emptyPhone2" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <label for="phone" v-if="falsePhone2" class="myValidationText"
                >Telefon numarası 0 ile başlamalıdır!</label
              >
              <label for="phone" v-if="shortPhone2" class="myValidationText"
                >Telefon numarası 11 hane olmalıdır!</label
              >
            </div>
            <v-input placeholder="Adres" v-model="address" />
            <label for="password" v-if="emptyAddress" class="myValidationText"
              >Bu kısım boş geçilemez!</label
            >
            <v-input
              placeholder="Mesaj İçin Telefon"
              style="width: 47%"
              v-model="message_phone"
            />
            <label for="phone" v-if="emptyPhone" class="myValidationText"
              >Bu kısım boş geçilemez!</label
            >
            <label for="phone" v-if="falsePhone" class="myValidationText"
              >Telefon numarası 0 ile başlamalıdır!</label
            >
            <label for="phone" v-if="shortPhone" class="myValidationText"
              >Telefon numarası 11 hane olmalıdır!</label
            >
            <v-input
              placeholder="Web Adresi"
              style="width: 47%"
              v-model="web"
            />

            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
          <!-- <label>Logo Fotoğrafı</label>
        <MyDormGaleriLogo :gallery="imagesLogo"/>
<label>Kapak Fotoğrafı</label>
        <MyDormGaleriCover :gallery="imagesCover"/> -->
          <div>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>
      <div>
        <div class="register-box__info col-xl-12">
          <div class="or blue">
            <p class="or__title-blue">YETKİLİ BİLGİLERİ</p>
          </div>
          <v-input placeholder="Yurt Yetkilisi" v-model="member" />
          <div class="row">
            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Yetkili E-Posta" v-model="member_email" />
            </div>

            <div class="col-xs-12 col-md-6">
              <v-input placeholder="Yetkili Telefon" v-model="mobile_phone" />
              <label for="phone" v-if="emptyPhone3" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <label for="phone" v-if="falsePhone3" class="myValidationText"
                >Telefon numarası 0 ile başlamalıdır!</label
              >
              <label for="phone" v-if="shortPhone3" class="myValidationText"
                >Telefon numarası 11 hane olmalıdır!</label
              >
            </div>
          </div>
        </div>

        <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">ÖZET BİLGİLER</div>
          <div class="register-box_input">
            <v-input
              placeholder="Türkçe Açıklama"
              class="textarea"
              v-model="content"
            />
            <v-input
              placeholder="İngilizce Açıklama"
              class="textarea"
              v-model="content_en"
            />
            <div class="groups">
              <!-- <v-select :options="days" placeholder="Kapasite" v-model="capacity" style="font-weight: bold"/> -->
              <v-input placeholder="Kapasite" v-model="capacity" />
              <label
                for="password"
                v-if="emptyCapacity"
                class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <v-select
                :options="meals"
                placeholder="Yemek Hizmeti"
                @onselect="selectMeal"
              />
              <label for="password" v-if="emptyMeal" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
              <v-select
                :options="wifi"
                placeholder="WIFI Seçeneği"
                style="width: 225%;margin-right: 0;"
                @onselect="selectWifi"
              />
              <label for="password" v-if="emptyWifi" class="myValidationText"
                >Bu kısım boş geçilemez!</label
              >
            </div>
          </div>
        </div>

        <!--         <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">ODA TİPLERİ</div>
          <div class="room-type">
              <my-dorm-room-type/>
          </div>
        </div> -->

        <div class="login-box register-box choose-gen col-xl-12">
          <div class="my-dorm__title">HİZMET VE ÖZELLİKLER</div>
          <!--           <div class="room-type">
            <div >
              <MyDormBuildingServices/>
            </div>
          </div>
          <div class="room-type">
            <div >
              <my-dorm-room-services/>
            </div>
          </div> -->
          <div class="room-type">
            <div>
              <MyDormServices :bina="bina" :oda="oda" :hizmetler="hizmetler" />
            </div>
          </div>
        </div>
      </div>

      <div class="login-box register-box col-xl-12">
        <div class="my-dorm__title">HARİTA BİLGİLERİ</div>
        <div class="register-box_input">
          <v-input placeholder="Enlem" class="textarea" v-model="lat" />
          <v-input placeholder="Boylam" class="textarea" v-model="lng" />
        </div>
      </div>

      <div class="login-box register-box col-xl-12">
        <div class="my-dorm__title">MULTIMEDIA</div>
        <div class="register-box_input">
          <v-select
            class="big-select"
            :options="videotypes"
            placeholder="Video Tipi"
            style="width: 25%;margin-right: 0;"
            v-model="type_id"
            @onselect="selectVideo"
          />
          <v-input
            placeholder="Video Url"
            class="textarea"
            v-model="video_url"
          />
          <v-input
            placeholder="Sanal Tur"
            class="textarea"
            v-model="virtual_tour"
          />
        </div>
      </div>

      <!--         <div class="login-box register-box col-xl-12">
          <div class="my-dorm__title">GENEL BİLGİLER</div>
          <div class="register-box_input">
            <v-input placeholder="Tesisler" class="textarea" v-model="facilities"/>
            <v-input placeholder="Avantajlar" class="textarea" v-model="advantages"/>
            <v-input placeholder="Etkinlikler" class="textarea" v-model="events"/>
            <v-input placeholder="Ulaşım" class="textarea" v-model="transportation"/>
            <v-input placeholder="Diğer" class="textarea" v-model="advantages"/>
          </div>
        </div> -->

      <div class="login-box register-box col-xl-12">
        <div class="my-dorm__title">META BİLGİLERİ</div>
        <div class="register-box_input">
          <v-input
            placeholder="Açıklama"
            class="textarea"
            v-model="description"
          />
          <v-input
            placeholder="Anahtar Kelimeler"
            class="textarea"
            v-model="keywords"
          />
        </div>
      </div>

      <div class="login-box register-box col-xl-12">
        <div class="my-dorm__title">LOKASYON BİLGİLERİ</div>
        <div class="register-box_input">
          <label for>Hangi Üniversitelere Yakın?</label>
          <multiselect
            v-model="university"
            tag-placeholder="Üniversite Ekle"
            placeholder="Üniversite Ara"
            label="name"
            :close-on-select="false"
            :clear-on-select="false"
            :custom-label="nameWithUniversity"
            track-by="id"
            :options="universities"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          ></multiselect>
        </div>
      </div>

      <div class="login-box register-box col-xl-12">
        <div class="my-dorm__title">RESİM GALERİSİ</div>
        <div class="register-box_input">
          <div>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
          <MyDormGaleri :gallery="images" />
          <div>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </div>
      </div>

      <div
        class="branch-add mywidth"
        v-on:click="saveDorm()"
        v-if="messageEnabled"
      >
        <button class="branch-add__button">
          <p class="branch-add__txt">KAYDET</p>
          <span class="branch-add__icon">
            <svg-icon type="icon-plus" />
          </span>
        </button>
      </div>
      <div class="branch-add mywidth" v-if="!messageEnabled">
        <button class="branch-add__button">
          <p class="branch-add__txt">KAYDEDİYOR</p>
          <span class="branch-add__icon">
            <svg-icon type="icon-plus" />
          </span>
        </button>
      </div>
    </container>
    <div></div>
    <Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">ŞUBE EKLENDİ!</h2>
          <div class="or">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue"
                >Kayıt ettiğiniz yurt sistemimize eklenmiştir.</span
              >
            </p>
            <p>
              <span class="mycolorBlue"
                >Eklediğiniz yurdu istediğiniz zaman güncelleyebilirsiniz.</span
              >
            </p>
          </div>
        </div>
      </div>
    </Modal2>
    <Modal2 :active="showErrorMessage" @onModalClose="closeModal3">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title2">ŞUBE EKLENEMEDİ!</h2>
          <div class="or">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p>
              <span class="mycolorBlue">Malesef şu anda şube eklenemedi</span>
            </p>
            <p>
              <span class="mycolorBlue">Lütfen daha sonra tekrar deneyin.</span>
            </p>
          </div>
        </div>
      </div>
    </Modal2>
  </div>
</template>

<script>
import Modal2 from '@/components/Modal2'
import MyDormGaleri from '@/components/MyDormGaleri2'
import MyDormGaleriCover from '@/components/MyDormGaleriCover'
import MyDormGaleriLogo from '@/components/MyDormGaleriLogo'
import MyDormRoomType from '@/components/MyDormRoomType'
import MyDormServices from '@/components/MyDormServices'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DormDashboardHead from '../components/Dorm/DormDashboardHead.vue'
export default {
  name: 'DormUserDormDetail',
  components: {
    MyDormGaleri,
    MyDormServices,
    Modal2,
    MyDormRoomType,
    MyDormGaleriLogo,
    MyDormGaleriCover,
    Multiselect,
    DormDashboardHead
  },
  data() {
    return {
      messageEnabled: true,
      showSuccessMessage: false,
      showErrorMessage: false,
      dormLogo: null,
      faculties: [],
      university: [],
      universities: [],
      imagesLogo: [],
      imagesCover: [],
      images: [],
      errors: [],
      bina: [
        {
          title: 'Çamaşır ve Ütü Odası',
          id: 1,
          selected: false
        },
        {
          title: 'Etüt Odası',
          id: 2,
          selected: false
        },
        {
          title: 'Asansör',
          id: 3,
          selected: false
        },
        {
          title: 'Kafeterya',
          id: 4,
          selected: false
        },
        {
          title: 'Çizim Odası',
          id: 6,
          selected: false
        },
        {
          title: 'Spor Salonu',
          id: 8,
          selected: false
        },
        {
          title: 'Hobi ve Oyun Odası',
          id: 19,
          selected: false
        }
      ],
      oda: [
        {
          title: 'Balkonlu Oda',
          id: 5,
          selected: false
        },
        {
          title: 'Mini Buzdolabı',
          id: 9,
          selected: false
        },
        {
          title: 'Klima',
          id: 10,
          selected: false
        },
        {
          title: 'Duş ve Wc',
          id: 11,
          selected: false
        },
        {
          title: 'TV ve Uydu Yayını',
          id: 12,
          selected: false
        },
        {
          title: 'Sınırsız İnternet',
          id: 13,
          selected: false
        },
        {
          title: 'Kişisel Dolap',
          id: 22,
          selected: false
        },
        {
          title: 'Çalışma Masası',
          id: 23,
          selected: false
        },
        {
          title: 'Oda Telefonu',
          id: 30,
          selected: false
        }
      ],
      hizmetler: [
        {
          title: '24 Saat Güvenlik',
          id: 16,
          selected: false
        },
        {
          title: 'Kamera Sistemi',
          id: 17,
          selected: false
        },
        {
          title: 'Lig TV',
          id: 18,
          selected: false
        },
        {
          title: 'Mutfak',
          id: 20,
          selected: false
        },
        {
          title: 'Ücretsiz Servis',
          id: 21,
          selected: false
        },
        {
          title: 'Sabah Kahvaltısı',
          id: 26,
          selected: false
        },
        {
          title: 'Akşam Yemeği',
          id: 27,
          selected: false
        },
        {
          title: 'Günlük Temizlik',
          id: 28,
          selected: false
        },
        {
          title: 'Haftalık Temizlik',
          id: 29,
          selected: false
        }
      ],
      video_type: null,
      video_url: null,
      virtual_tour: null,
      mail: null,
      emptyName: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      falsePhone2: false,
      shortPhone2: false,
      emptyPhone2: false,
      falsePhone3: false,
      shortPhone3: false,
      emptyPhone3: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyAddress: false,
      emptyCapacity: false,
      emptyMeal: false,
      emptyWifi: false,
      props: [],
      // props.*: [],
      cities: [],
      districts: [],
      faculties: [],
      type_id: 1,
      city_id: null,
      district_id: null,
      name: '',
      slug: '',
      keywords: '',
      description: '',
      member: '',
      member_email: '',
      member_phone: '',
      capacity: null,
      is_wifi: null, // undefined','
      meal: null, // undefined',
      content: '', // undefined',
      content_en: '', // undefined',
      facilities: null, // undefined',
      advantages: null, // undefined',
      events: null, // undefined',
      transportation: null, // undefined',
      other: null, // undefined',
      phone: null, // regex:/(0)[0-9]{10}/|not_in:null,undefined',
      mobile_phone: '', // required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
      message_phone: '', // required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
      fax: '',
      email: '',
      web: '', // undefined',
      address: '', // ' => 'required|not_in:null,undefined',
      lat: '', // undefined',
      lng: '', // undefined',
      note: '',

      links: [
        {
          id: 0,
          title: 'İstatistik Özeti',
          to: '/yurtlar-istatistik'
        },
        {
          id: 1,
          title: 'Bilgilerim',
          to: '/yurt-hesap-bilgileri'
        },
        {
          id: 2,
          title: 'Rezervasyonlar',
          to: '/kullanici-teklifler'
        },
        {
          id: 3,
          title: 'Mesajlar',
          to: '/mesaj-liste'
        },
        {
          id: 4,
          title: 'Yurtlarım',
          to: '/yurt-sube'
        },
        {
          id: 5,
          title: 'İlanlarım',
          to: '/kullanici-favoriler'
        },
        {
          id: 6,
          title: 'Yorumlar',
          to: '/yurtlar-yorumlar'
        }
      ],
      days: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days1: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      days2: [
        {
          label: '01',
          value: '01',
          selected: false
        },
        {
          label: '02',
          value: '02',
          selected: false
        },
        {
          label: '03',
          value: '03',
          selected: false
        }
      ],
      videotypes: [
        {
          name: 'Youtube',
          id: '1'
        },
        {
          name: 'Vimeo',
          id: '2'
        }
      ],
      genders: [
        {
          name: 'Erkek Öğrenci Yurdu',
          id: '1',
          selected: false
        },
        {
          name: 'Kız Öğrenci Yurdu',
          id: '2',
          selected: false
        }
      ],
      meals: [
        {
          name: '1 Öğün',
          id: '1',
          selected: false
        },
        {
          name: '2 öğün',
          id: '2',
          selected: false
        },
        {
          name: '3 öğün',
          id: '3',
          selected: false
        }
      ],
      wifi: [
        {
          name: 'Wifi Var',
          id: '1',
          selected: false
        },
        {
          name: 'Wifi Yok',
          id: '2',
          selected: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['first_name', 'last_name', 'phone', 'mail1'])
  },
  methods: {
    getData() {
      this.axios.get('dorms/create').then(response => {
        // this.users = response.data.users;
        // this.cities = response.data.cities;
        // this.properties = response.data.properties;
        this.universities = response.data.universities
        // console.log(this.universities);
      })
    },
    nameWithUniversity({ name, university }) {
      if (university) {
        return `${name} — (${university.name})`
      }
      return name
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
      }
      this.universities.push(tag)
      this.university.push(tag.id)
    },
    closeModal2() {
      this.showSuccessMessage = false
    },
    closeModal3() {
      this.showErrorMessage = false
    },
    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    saveDorm() {
      const mytoken = window.localStorage.getItem('access_token')
      this.slug = this.slugify(this.name)
      let self = this
      this.falseEmail = false
      this.emptyName = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyPhone2 = false
      this.falsePhone2 = false
      this.shortPhone2 = false
      this.emptyPhone3 = false
      this.falsePhone3 = false
      this.shortPhone3 = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyAddress = false
      this.emptyCapacity = false
      this.emptyMeal = false
      this.emptyWifi = false
      const verifiedMail = this.validateEmail(this.email)

      if (!this.email) {
        this.emptyEmail = true
      } else if (this.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.name) {
        this.emptyName = true
      }
      if (!this.address) {
        this.emptyAddress = true
      }
      if (!this.capacity) {
        this.emptyCapacity = true
      }
      if (!this.meal) {
        this.emptyMeal = true
      }
      if (!this.is_wifi) {
        this.emptyWifi = true
      }
      if (!this.message_phone) {
        this.emptyPhone = true
      }
      if (this.message_phone && !this.message_phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (
        this.message_phone &&
        !this.falsePhone &&
        this.message_phone.length != 11
      ) {
        this.shortPhone = true
      }

      if (!this.phone) {
        this.emptyPhone2 = true
      }
      if (this.phone && !this.phone.startsWith('0')) {
        this.falsePhone2 = true
      }

      if (this.phone && !this.falsePhone2 && this.phone.length != 11) {
        this.shortPhone2 = true
      }
      if (!this.mobile_phone) {
        this.emptyPhone3 = true
      }
      if (this.mobile_phone && !this.mobile_phone.startsWith('0')) {
        this.falsePhone3 = true
      }

      if (
        this.mobile_phone &&
        !this.falsePhone3 &&
        this.mobile_phone.length != 11
      ) {
        this.shortPhone3 = true
      }

      if (
        !this.emptyName &&
        !this.emptyEmail &&
        !this.falseEmail &&
        verifiedMail &&
        !this.emptyPhone &&
        !this.falsePhone &&
        !this.shortPhone &&
        !this.emptyPhone2 &&
        !this.falsePhone2 &&
        !this.shortPhone2 &&
        !this.emptyPhone3 &&
        !this.falsePhone3 &&
        !this.shortPhone3 &&
        !this.emptyAddress &&
        !this.emptyCapacity &&
        !this.emptyMeal &&
        !this.emptyWifi
      ) {
        /*       for (let i = 0; i < this.props.length; i++) {
        formData.append("props[]", this.props[i]);
      } */

        /*

      if(this.props.length > 0) {
        for (let i = 0; i < this.props.length; i++) {
          formData.append("props[]", this.props[i]);
        }
      } */

        var data = {
          type_id: this.type_id,
          city_id: this.city_id,
          district_id: this.district_id,
          name: this.name, // required',
          slug: this.slug, // required',
          keywords: this.keywords,
          description: this.description,
          member: self.member,
          capacity: self.capacity,
          is_wifi: self.is_wifi, // undefined',
          meal: self.meal, // undefined',
          content: this.content, // undefined',
          content_en: this.content_en, // undefined',
          facilities: '', // undefined',
          advantages: '', // undefined',
          events: '', // undefined',
          transportation: '', // undefined',
          other: '', // undefined',
          phone: this.phone, // regex:/(0)[0-9]{10}/|not_in:null,undefined',
          mobile_phone: self.mobile_phone, // required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
          message_phone: self.message_phone, // required|regex:/(0)[0-9]{10}/|not_in:null,undefined',
          fax: self.fax,
          email: this.email,
          web: this.web, // undefined',
          address: self.address, // ' => 'required|not_in:null,undefined',
          lat: this.lat, // undefined',
          lng: this.lng, // undefined',
          note: 'notum', // undefined',
          video_url: this.video_url,
          video_type: this.video_type,
          virtual_tour: this.virtual_tour,
          cover: this.imagesCover[0],
          logo: this.imagesLogo[0]
          // display_cover: images[0]
        }
        const formData = new FormData()
        Object.keys(data).map(e => {
          formData.append(e, data[e])
        })
        // formData.append("video[]", this.video);

        if (this.images.length > 0) {
          for (let i = 0; i < this.images.length; i++) {
            formData.append('images[]', this.images[i])
          }
        }
        for (let i = 0; i < this.bina.length; i++) {
          if (this.bina[i].selected) {
            formData.append('props[]', this.bina[i].id)
          }
        }
        for (let i = 0; i < this.oda.length; i++) {
          if (this.oda[i].selected) {
            formData.append('props[]', this.oda[i].id)
          }
        }
        for (let i = 0; i < this.hizmetler.length; i++) {
          if (this.hizmetler[i].selected) {
            formData.append('props[]', this.hizmetler[i].id)
          }
        }

        if (this.university.length > 0) {
          for (let i = 0; i < this.university.length; i++) {
            formData.append('faculties[]', this.university[i].id)
          }
        }
        this.messageEnabled = false
        axios
          .post('/dorm/dorms/', formData)
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              self.messageEnabled = true
              self.showSuccessMessage = true
            } else {
              self.showErrorMessage = true
              self.messageEnabled = true
            }
          })
          .catch(e => {
            self.messageEnabled = true
            this.errors.push(e)
          })
      }
    },
    getCities() {
      let self = this
      axios
        .get('/site/home/select-cities')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectCity(opt) {
      this.city_id = opt.id
      this.districtEnabled = true
      let self = this
      axios
        .get(`/site/cities/${opt.slug}`)
        .then(response => {
          self.districts = response.data.districts
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectDistrict(opt) {
      this.district_id = opt.id
    },
    selectGender(opt) {
      this.type_id = opt.id
    },
    selectVideo(opt) {
      this.video_type = opt.name
    },
    selectWifi(opt) {
      this.is_wifi = opt.id
    },
    selectMeal(opt) {
      this.meal = opt.name
    },
    slugify(string) {
      const a =
        'àáäâãåăæąçćčđèéėëêęǵḧìíïîįłḿǹńňñòóöôœøṕŕřßśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
      const b =
        'aaaaaaaaacccdeeeeeeghiiiiilmnnnnooooooprrssssttuuuuuuuuuwxyyzzz------'
      const p = new RegExp(a.split('').join('|'), 'g')

      return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
    }
  },
  created() {
    this.dormLogo = window.localStorage.getItem('cache:dorm_logo')
    this.email = window.localStorage.getItem('mail')
    this.username = window.localStorage.getItem('username')
    this.message_phone = window.localStorage.getItem('phone1')
    this.phone = window.localStorage.getItem('phone1')
    this.getCities()
    // this.getData()
  }
}
</script>
<style lang="scss">
@import '../assets/scss/components/dormAdd';
@import '../assets/scss/components/dorm-branch';

.mywidth {
  width: 5px;
}
</style>
